/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SageIntacctCreateNewProjectModal_QueryVariables = {};
export type SageIntacctCreateNewProjectModal_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly company: {
            readonly " $fragmentRefs": FragmentRefs<"SageIntacctCreateNewProjectModal_company">;
        } | null;
    } | null;
};
export type SageIntacctCreateNewProjectModal_Query = {
    readonly response: SageIntacctCreateNewProjectModal_QueryResponse;
    readonly variables: SageIntacctCreateNewProjectModal_QueryVariables;
};



/*
query SageIntacctCreateNewProjectModal_Query {
  viewer {
    actualPersonId
    component(name: "sage_intacct_new_project_modal")
    company {
      ...SageIntacctCreateNewProjectModal_company
      id
    }
    id
  }
}

fragment SageIntacctCreateNewProjectModal_company on Company {
  clients {
    edges {
      node {
        id
        name
        sageIntacctCustomerId
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "sage_intacct_new_project_modal"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"sage_intacct_new_project_modal\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SageIntacctCreateNewProjectModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SageIntacctCreateNewProjectModal_company"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SageIntacctCreateNewProjectModal_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClientTypeConnection",
                "kind": "LinkedField",
                "name": "clients",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClientTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Client",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "sageIntacctCustomerId",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "SageIntacctCreateNewProjectModal_Query",
    "operationKind": "query",
    "text": "query SageIntacctCreateNewProjectModal_Query {\n  viewer {\n    actualPersonId\n    component(name: \"sage_intacct_new_project_modal\")\n    company {\n      ...SageIntacctCreateNewProjectModal_company\n      id\n    }\n    id\n  }\n}\n\nfragment SageIntacctCreateNewProjectModal_company on Company {\n  clients {\n    edges {\n      node {\n        id\n        name\n        sageIntacctCustomerId\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'cd4af618ace24c3d61ea4cc19699020c';
export default node;
